exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.noPaddingExpansionPanel > .v-expansion-panel-content__wrap {\n    padding-left: 0;\n    padding-right: 0;\n    padding-bottom: 0;\n}\n", ""]);
